<template>
	<Card :class="cn(propertyCardBodyVariants({ size, variant }), props.class)">
		<PropertyCardHeader
			class="group/card z-10"
			v-bind="props"
			:is-mouse-over-card-header="isMouseOverCardHeader"
			:card-position="cardPosition"
			:section="section"
			@mouseover="handleMouseOver"
			@mouseleave="handleMouseLeave"
		>
			<PropertyCardContent
				v-bind="props"
				@mouseover="handleMouseOver"
				@mouseleave="handleMouseLeave"
			/>
			<PropertyCardFooter v-if="variant === 'fullFace'" v-bind="props" />
		</PropertyCardHeader>

		<PropertyCardFooter v-if="variant !== 'fullFace'" v-bind="props" />
	</Card>
</template>

<script lang="ts" setup>
import type { HTMLAttributes } from 'vue';

import {
	propertyCardBodyVariants,
	PropertyCardFooter,
	PropertyCardHeader,
	type PropertyCardFooterProps
} from '.';
import { Card } from '../ui/card';

import { cn } from '@/utils';
import type { Property } from '~/core/entities/property';
import type { SectionName } from '~/types/mixpanel';

export type PropertyCardProps = {
	class?: HTMLAttributes['class'];
	property: Property;
	isFavorited?: boolean;
	size?: 'sm' | 'md' | 'lg';
	variant?:
		| 'whiteBackground'
		| 'transparentBackground'
		| 'transparentBackgroundWithoutBorder'
		| 'fullFace';
	cardPosition?: number;
	section?: SectionName;
	asTags?: PropertyCardFooterProps['asTags'];
};

const props = withDefaults(defineProps<PropertyCardProps>(), {
	variant: 'whiteBackground',
	commercialId: 'XX38232',
	size: 'sm'
});

const isMouseOverCardHeader = ref(false);

function handleMouseOver() {
	isMouseOverCardHeader.value = true;
}
function handleMouseLeave() {
	isMouseOverCardHeader.value = false;
}
</script>
